@if (isBannerVisible && offersEligible && banners?.length) {
  @for (banner of banners; track banner; let i = $index) {
    @if (!isBannerClosed(i)) {
      <article
        appBannerObserver
        (bannerVisible)="onBannerDisplayed(banner)"
        (click)="onBannerClick($event, banner)"
        class="offer-banner d-flex flex-column flex-md-row align-items-center p-4 position-relative"
        >
        <div class="d-flex align-items-start">
          <img
            src="/icons/confirmation-positive-green.png"
            alt=""
            class="img-fluid"
            style="width: 30px; height: auto; margin-right: 5px;"
            />
          <div class="d-flex flex-column">
            <p class="mb-0 top-text">{{ getHeadline(banner) }}</p>
            @if (getSubHeadline(banner); as subCopy) {
              <p class="mb-0">{{ subCopy }}</p>
            }
          </div>
        </div>
        <button
          type="button"
          class="btn-primary ml-md-auto d-inline-flex align-items-center justify-content-center"
          (click)="onViewOffer(banner, $event)"
          >
          {{ getPrimaryCtaLabel(banner) }}
        </button>
        @if (showSecondaryCta(banner)) {
          <button
            type="button"
            class="btn-secondary ml-md-2 mt-3 mt-md-0 d-inline-flex align-items-center justify-content-center"
            (click)="onSecondaryCtaClick(banner, $event)"
            >
            {{ banner.secondaryCtaLabel }}
          </button>
        }
        <button
          class="border-0 bg-transparent p-0 position-absolute obc-close"
          aria-label="close offers banner"
          (click)="closeBanner($event, i)"
          >
          <span aria-hidden="true">&times;</span>
        </button>
      </article>
    }
  }
}
